import React, { useState } from "react";
import "./LifeStyleAddOrUpdatePopup.css";

interface Props {
  handleClose: any;
  handleConfirmation: any;
  item?: any;
}

const toDateInputValue = (value: any) => {
  const date = value ? new Date(value) : new Date();
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const toInputString = (value: any) =>
  value === null || value === undefined || value === 0 ? "" : `${value}`;

export const LifeStyleAddOrUpdatePopup = (props: Props) => {
  const isEdit = !!(props.item && props.item.lifeStyleId);

  const [date, setDate] = useState(toDateInputValue(props.item?.date));
  const [weight, setWeight] = useState<string>(
    toInputString(props.item?.weight)
  );
  const [muscles, setMuscles] = useState<string>(
    toInputString(props.item?.muscles)
  );
  const [fat, setFat] = useState<string>(toInputString(props.item?.fat));

  const weightValue = parseFloat(weight.replace(",", "."));
  const isWeightValid = !isNaN(weightValue) && weightValue > 0;

  const toPercentText = (value: string) => {
    const parsed = parseFloat(value.replace(",", "."));
    if (!isWeightValid || isNaN(parsed) || parsed <= 0) return "";
    return `${((parsed / weightValue) * 100).toFixed(1)} % z váhy`;
  };

  const musclesPercent = toPercentText(muscles);
  const fatPercent = toPercentText(fat);

  const handleSave = () => {
    if (!isWeightValid) {
      return;
    }

    const parseOptional = (value: string) => {
      const parsed = parseFloat(value.replace(",", "."));
      return isNaN(parsed) ? 0 : parsed;
    };

    props.handleConfirmation({
      lifeStyleId: props.item?.lifeStyleId ?? 0,
      date: date || toDateInputValue(new Date()),
      weight: weightValue,
      muscles: parseOptional(muscles),
      fat: parseOptional(fat),
    });
  };

  return (
    <div className="lsPopupRoot">
      <div className="lsOverlay" onClick={props.handleClose}></div>

      <div className="lsModal">
        <div className="lsModal__header">
          <div className="lsModal__title">
            <i className="fas fa-weight"></i>
            {isEdit ? "Úprava záznamu" : "Nový záznam"}
          </div>
          <button
            className="lsModal__close"
            onClick={props.handleClose}
            type="button"
            aria-label="Zavřít"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="lsModal__body">
          <div className="lsField">
            <label htmlFor="lsDate">Datum</label>
            <input
              type="date"
              id="lsDate"
              value={date}
              onChange={(event) => setDate(event.target.value)}
            />
          </div>

          <div className="lsField">
            <label htmlFor="lsWeight">
              Váha (kg) <span className="lsRequired">*</span>
            </label>
            <input
              type="number"
              id="lsWeight"
              step="0.1"
              min="0"
              placeholder="např. 82.5"
              className={!isWeightValid && weight !== "" ? "lsInvalid" : ""}
              value={weight}
              onChange={(event) => setWeight(event.target.value)}
            />
          </div>

          <div className="lsOptional">
            <div className="lsOptional__title">
              <i className="fas fa-percentage"></i> Volitelné (v kg)
            </div>
            <div className="lsOptional__fields">
              <div className="lsField">
                <label htmlFor="lsMuscles">Svaly (kg)</label>
                <input
                  type="number"
                  id="lsMuscles"
                  step="0.1"
                  min="0"
                  placeholder="—"
                  value={muscles}
                  onChange={(event) => setMuscles(event.target.value)}
                />
                {musclesPercent && (
                  <span className="lsHint">{musclesPercent}</span>
                )}
              </div>
              <div className="lsField">
                <label htmlFor="lsFat">Tuk (kg)</label>
                <input
                  type="number"
                  id="lsFat"
                  step="0.1"
                  min="0"
                  placeholder="—"
                  value={fat}
                  onChange={(event) => setFat(event.target.value)}
                />
                {fatPercent && <span className="lsHint">{fatPercent}</span>}
              </div>
            </div>
          </div>
        </div>

        <div className="lsModal__footer">
          <button
            type="button"
            className="lsBtn lsBtn--ghost"
            onClick={props.handleClose}
          >
            Storno
          </button>
          <button
            type="button"
            className="lsBtn lsBtn--primary"
            disabled={!isWeightValid}
            onClick={handleSave}
          >
            <i className="fas fa-check"></i>
            {isEdit ? "Uložit" : "Přidat"}
          </button>
        </div>
      </div>
    </div>
  );
};
